import * as React from 'react';
import { SkeletonLoadingProps, variantMap } from './skeleton-loading.constants';
import { loadingText } from './skeleton-loading.components';
import { cn } from '@restworld/utils-common';

export const SkeletonLoading = ({ variant, animation = true }: SkeletonLoadingProps) => (
  <Wrapper animation={animation}>
    {variantMap[variant]}
    {loadingText}
  </Wrapper>
);
export default SkeletonLoading;
const Wrapper = ({ animation, className, ...props }: any) => (
  <div className={cn(animation ? 'animate-pulse' : '', 'w-full', className)} {...props} />
);
export * from './skeleton-loading.components';
export * from './skeleton-element-loading';
